import React from "react";
import Collaborators from "../../components/Collaborators";
import Container from "../../components/Container";
import ContainerDivider from "../../components/ContainerDivider";
import EvaluationForm from "../../components/EvaluationForm";
import Footer from "../../components/Footer";
import ListHeader from "../../components/ListHeader";
import Navbar from "../../components/Navbar";
import Spacer from "../../components/Spacer";
import SubscriptionSection from "../../components/SubscriptionSection";

const Evaluation = () => {
  return (
    <div className="EvaluationPage">
      <Navbar />

      <Container>
        <div className="mt-8">
          <ListHeader title="Evaluation" header="Feedback" />
        </div>

        <EvaluationForm />
      </Container>

      <Spacer>
        <ContainerDivider />
        <Collaborators />
      </Spacer>

      <SubscriptionSection />
      <Footer />
    </div>
  );
};

export default Evaluation;
